import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import MyLeavesTable from "@/components/leaves/MyLeavesTable";
import RequestLeaveForm from "@/components/leaves/RequestLeaveForm";
import ApprovalsTable from "@/components/leaves/ApprovalsTable";

export default function LeavesPage() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [mine, setMine] = useState([]);
  const [all, setAll] = useState([]);

  const loadMine = useCallback(async () => {
    const r = await api.get("/leaves/mine");
    setMine(r.data);
  }, []);

  const loadAll = useCallback(async () => {
    if (!isAdmin) return;
    const r = await api.get("/leaves");
    setAll(r.data);
  }, [isAdmin]);

  useEffect(() => {
    loadMine();
    loadAll();
  }, [loadMine, loadAll]);

  const refreshAll = () => {
    loadMine();
    loadAll();
  };

  return (
    <div className="space-y-6" data-testid="leaves-page">
      <header>
        <div className="overline">Time off</div>
        <h1 className="mt-2 font-display text-4xl font-bold tracking-tight">
          Leaves
        </h1>
      </header>

      <Tabs defaultValue="mine">
        <TabsList>
          <TabsTrigger value="mine" data-testid="leaves-tab-mine">My leaves</TabsTrigger>
          <TabsTrigger value="new" data-testid="leaves-tab-new">Request leave</TabsTrigger>
          {isAdmin && (
            <TabsTrigger value="approvals" data-testid="leaves-tab-approvals">
              Approvals
            </TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="mine">
          <MyLeavesTable items={mine} />
        </TabsContent>

        <TabsContent value="new">
          <RequestLeaveForm onSubmitted={refreshAll} />
        </TabsContent>

        {isAdmin && (
          <TabsContent value="approvals">
            <ApprovalsTable items={all} onDecided={refreshAll} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
